module.exports = __webpack_public_path__ + "img/titlePc24-safeimagekit.5b0eb844.png";